import { Navigate, Outlet } from 'react-router-dom';
import { useDeviceStore } from '@/stores/device.store';

/** Sell/Checkout require a bound ticket printer; otherwise route to /setup. */
export function RequireDeviceBound() {
  const bound = useDeviceStore((s) => Boolean(s.ticketPrinterId));
  if (!bound) {
    return <Navigate to="/setup" replace />;
  }
  return <Outlet />;
}
